import React, { lazy, Suspense } from "react";
var ExecutionEnvironment = require("exenv");
import CustomMeta from "../components/CustomMeta/CustomMeta";
import PropTypes from "prop-types";

// Components
const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
const Onboarding = lazy(() =>
  import(
    /* webpackChunkName: "Onboarding" */ "../components/Onboarding/Onboarding"
  )
);
import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

// Redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  mainDiv: {
    display: "flex",
    justifyContent: "center",
  },
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  heading: {
    paddingTop: theme.spacing(2),
  },
  subTitle: {
    padding: "0px 30px 0px 30px",
    textAlign: "center",
    fontSize: 20,
  },
}));

function onboarding(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Onboarding - Content Generator`}
        description={`Master Content Generator in minutes with our step-by-step onboarding guide. Learn how to create viral social media posts, optimize your content, and start driving targeted traffic to your website or store.`}
        url={`https://contentgenerator.io/onboarding`}
      />
      <Typography variant="h1" className={classes.heading}>
        Welcome to Content Generator!
      </Typography>
      <Typography className={classes.subTitle}>
        Follow these steps to get the most out of your Content Generator and
        start driving traffic from social media as fast as possible.
      </Typography>
      <div className={classes.mainDiv}>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            {props.user.authenticated ? <Onboarding /> : <LoginOrSignup />}
          </Suspense>
        )}
      </div>
    </div>
  );
}

onboarding.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(onboarding);
